import { shared } from '@/api/ad-task'
import { getAllTeams } from '@/api/open'

export default {
    components: {},
    props: {
        showSharedForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 18},
            roles: [],
            corporations: [],
            loading: false,
            rules: {
                team_ids: [{required: true, message: '请选择所属小组', trigger: 'change'}],
            },
            teams: [],
            refresh: false,
        }
    },
    computed: {
    },
    mounted() {
        //此处需要重新获取绑定的优化师
        getAllTeams().then(res => {
            this.teams = res.data.list
        })
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.shared()
            })
        },
        shared() {
            this.loading = true
            console.log('this.model', this.model)
            shared(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('共享成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            if (this.refresh) {
                this.$emit('success')
            }
            this.$emit('update:showSharedForm', false)
        }
    }
}
